import { useEffect, useRef, useState } from 'react';

// A dialog's save, one at a time. These dialogs close only once the server has answered, and their form's own `submitting` is never on (onSubmit does
// not wait for the request), so a second press while the first is in flight sent the same save again.
//  - startSaving(): false if a save is already on its way (do nothing); otherwise marks one as started and returns true;
//  - finishSaving(): call when the request has ended, whatever the outcome (a dialog that has closed by then is left alone);
//  - isSaving: for the button's `disabled`.
export const useSaveInFlight = () => {
    const isSavingRef = useRef(false);
    const isMountedRef = useRef(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const startSaving = (): boolean => {
        if (isSavingRef.current) {
            return false;
        }
        isSavingRef.current = true;
        setIsSaving(true);
        return true;
    };

    const finishSaving = () => {
        isSavingRef.current = false;
        if (isMountedRef.current) {
            setIsSaving(false);
        }
    };

    return { isSaving, startSaving, finishSaving };
};
